import { ajax } from '../index'

/**
 * 公司动态
 */
export default {
  // 企业内刊
  getArticleList() {
    return ajax.get('api', `/v1/article/list`, {})
  },
  // 获取企业动态
  getCompanyNews(params: any) {
    return ajax.get('api', `/v1/homepage/article_list`, params)
  }
}